import { api } from '@/lib/pos-api';

export async function downloadWorkbook({ title, headers, rows, notes = [], paper = 'A5', template = false }) {
  const response = await api.post('/documents/workbook', { title, headers, rows, notes, paper, template }, { responseType: 'blob' });
  const url = URL.createObjectURL(response.data), link = document.createElement('a');
  link.href = url; link.download = `${template ? 'lembar_kerja_' : ''}${title.replace(/[^a-z0-9_-]+/gi, '_').slice(0,100)}.xlsx`;
  document.body.appendChild(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000);
}
